import { graphql } from "@/api/graphql/types/gql.ts";

export const searchGroupsQuery = graphql(`
  query SearchGroups($request: LedgersMsSearchGroupsRequest!) {
    LedgersMsSearchGroups(request: $request) {
      data {
        id
        code
        codeHint
        category
      }
      pagination {
        page
        size
        total
      }
    }
  }
`);
